var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-textarea',{attrs:{"label":_vm.$t('label'),"filled":"","auto-grow":"","rows":"2"},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }